import { styled } from "styled-components";

export const Addbutton = styled.button`
	background-color: #003a50;
	color: #ffffff;
	padding: 0.7rem;
	display: flex;
	gap: 0.5rem;
	border-radius: 0.2rem;
	align-items: center;
	float: right;
`;

export const ChapterWrapper = styled.div`
	border-radius: 0.8rem;
	display: flex;
	gap: 1rem;
	border: 1px solid #dbe3e7;
	padding: 0.8rem;
	margin-top: 0.5rem;

	img {
		height: 6.5rem;
		width: 6.25rem;
		object-fit: cover;
		border-radius: 0.4rem;
	}

	main {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		width: 100%;

		div {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.chapter_text {
				color: #959595;
				font-size: 1rem;
			}

			.content_title {
				color: #003a50;
				font-size: 1rem;
				font-weight: 600;
			}

			button {
				cursor: pointer;
				border-radius: 0.5rem;
				background-color: #006770;
				color: #ffffff;
				padding: 0.5rem;
			}
		}
	}
`;

export const AddContentTemplate = styled.section`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 2.5rem;
	margin-top: 20px;

	.leftSection {
		width: 22%;
		max-width: 250px;

		.content {
			padding: 1rem;
			border: 1px solid #dbe3e7;

			h2 {
				font-size: 1.5rem;
				color: #006770;
				font-weight: 600;
			}

			p {
				font-size: 1.1rem;
				color: #999999;
			}
		}
	}

	.RightSection {
		width: 80%;
		display: flex;
		flex-direction: column;
		gap: 1rem;

		.addChapter {
			color: #999999;
		}
		&.w-full {
			width: 100% !important;
			padding-left: 20px;
			padding-right: 20px;
		}

		.form-group {
			color: #555;
			margin-top: 10px;
			display: flex;
			flex-direction: column;
			gap: 20px;

			label {
				color: #999999;
				font-weight: 400;
				font-size: 1rem;
			}

			img {
				object-fit: cover;
				height: 10rem;
			}

			.thumbnail_label {
				border: 1px solid #dbe3e7;
				padding: 0.5rem;
				width: 11rem;
				border-radius: 0.5rem;
			}

			input[type="file"] {
				color: transparent;
				width: 0;
				height: 0;
				display: none;
			}

			.inputText,
			input,
			textarea,
			select {
				font-weight: 600;
			}

			.inputText {
				width: fit-content;
				word-break: break-word;
				padding-right: 12px;
				/* text-transform: capitalize; */
			}

			.text_view {
				font-size: 17px;
				font-weight: 500;
				padding: 14px;
				border-radius: 5px;
				border: 1px solid #b8c8cf;
				background: #eff8f9;
			}

			input.edit,
			textarea.edit {
				margin-right: 16px;
				padding: 8px 14px;
				border-radius: 6px;
				border: 1px solid #b8c8cf;
			}

			select.edit {
				padding: 8px 14px;
				border-radius: 6px;
				border: 1px solid #b8c8cf;
			}

			.selectBadge {
				display: flex;
				align-items: center;
				gap: 24px;
				text-transform: uppercase;

				span {
					color: #333;
					padding: 8px 30px;
					border-radius: 5px;
					background: rgba(255, 120, 120, 0.2);
				}

				.statusIcon {
					font-size: 28px;
				}

				&.pending {
					span {
						background: #f9ffae;
					}
				}

				&.success,
				&.settled,
				&.enabled,
				&.approved {
					span {
						background: #dcf4e6;
					}
					.statusIcon {
						color: #00c24e;
					}
				}

				&.error,
				&.declined {
					span {
						background: #fde8e8;
					}
					.statusIcon {
						color: #ff0000;
					}
				}
			}

			.fileGroup {
				.viewFileBtn {
					display: flex;
					align-items: center;
					gap: 20px;
					padding: 12px 22px;
					width: fit-content;
					white-space: nowrap;
					border-radius: 6px;
					background: #006770;
					color: #fff;
					font-weight: 500;

					.fileIcon {
						color: #fff;
						font-size: 22px;
					}
					/* span {} */
				}
				.side_btn {
					font-weight: 500;
				}
			}
		}

		.headerActions {
			justify-content: space-between;
			margin-top: 18px;
			padding: 22px 24px;
			border: 1px solid #b8c8cf;
			border-radius: 14px;

			.progress {
				width: 37%;
			}
		}
	}
`;

export const UploadVideo = styled.button`
	border: 1px solid #dbe3e7;
	padding: 0.5rem;
	border-radius: 0.8rem;
	width: 11rem;
	display: flex;
	align-items: center;
	gap: 0.9rem;
	justify-content: flex-end;
`;
